module.exports = __webpack_public_path__ + "static/img/BMR.b1ed7f25.svg";